module.exports = __webpack_public_path__ + "img/call-center.049d396d.png";